import React from "react";
import styled from "styled-components";
import { OpenInNew } from "@mui/icons-material";

const Card = styled.div`
  background-color: ${({ theme }) => theme.card};
  padding: 20px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.primary + 20};
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 0 30px 4px rgba(0, 0, 0, 0.6);
    border-color: ${({ theme }) => theme.primary};
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 10px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin: 0;
`;

const Issuer = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.primary};
  margin: 0;
  font-weight: 500;
`;

const Date = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.text_secondary + 80};
  margin: 0;
`;

const Description = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
  margin: 8px 0 0 0;
  line-height: 1.5;
`;

const IconWrapper = styled.a`
  width: 36px;
  height: 36px;
  background-color: ${({ theme }) => theme.primary + 15};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    color: white;
  }

  svg {
    font-size: 18px;
    color: ${({ theme }) => theme.primary};
  }

  &:hover svg {
    color: white;
  }
`;

const CertificationCard = ({ certification }) => {
  return (
    <Card data-aos="fade-up" data-aos-once="true">
      <Header>
        <TitleSection>
          <Title>{certification.title}</Title>
          <Issuer>{certification.issuer}</Issuer>
          <Date>{certification.date}</Date>
        </TitleSection>
        <IconWrapper
          href={certification.credentialUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <OpenInNew />
        </IconWrapper>
      </Header>
      <Description>{certification.description}</Description>
    </Card>
  );
};

export default CertificationCard;
